/**
 * @fileoverview gRPC-Web generated client stub for stronachgroup.first.racehorse360
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v0.0.0
// source: stronachgroup/first/racehorse360/facility_blackout_service.proto

/* eslint-disable */
// @ts-nocheck

const grpc = {};
grpc.web = require("grpc-web");

var google_api_annotations_pb = require("../../../google/api/annotations_pb.js");

var google_api_visibility_pb = require("../../../google/api/visibility_pb.js");

var stronachgroup_first_racehorse360_messages_pb = require("../../../stronachgroup/first/racehorse360/messages_pb.js");
const proto = {};
proto.stronachgroup = {};
proto.stronachgroup.first = {};
proto.stronachgroup.first.racehorse360 = require("./facility_blackout_service_pb.js");

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.FacilityBlackoutServiceClient =
  function FacilityBlackoutServiceClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.FacilityBlackoutServicePromiseClient =
  function FacilityBlackoutServicePromiseClient(
    hostname,
    credentials,
    options
  ) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest,
 *   !proto.stronachgroup.first.racehorse360.FacilityBlackout>}
 */
const methodDescriptor_FacilityBlackoutService_CreateFacilityBlackout =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.FacilityBlackoutService/CreateFacilityBlackout",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.CreateFacilityBlackoutRequest,
    stronachgroup_first_racehorse360_messages_pb.FacilityBlackout,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.FacilityBlackout.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.FacilityBlackout)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.FacilityBlackout>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.FacilityBlackoutServiceClient.prototype.createFacilityBlackout =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityBlackoutService/CreateFacilityBlackout",
      request,
      metadata || {},
      methodDescriptor_FacilityBlackoutService_CreateFacilityBlackout,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.FacilityBlackout>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.FacilityBlackoutServicePromiseClient.prototype.createFacilityBlackout =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityBlackoutService/CreateFacilityBlackout",
      request,
      metadata || {},
      methodDescriptor_FacilityBlackoutService_CreateFacilityBlackout
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullFacilityBlackoutsRequest,
 *   !proto.stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse>}
 */
const methodDescriptor_FacilityBlackoutService_PullFacilityBlackouts =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.FacilityBlackoutService/PullFacilityBlackouts",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullFacilityBlackoutsRequest,
    stronachgroup_first_racehorse360_messages_pb.PullFacilityBlackoutsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullFacilityBlackoutsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullFacilityBlackoutsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullFacilityBlackoutsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.FacilityBlackoutServiceClient.prototype.pullFacilityBlackouts =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityBlackoutService/PullFacilityBlackouts",
      request,
      metadata || {},
      methodDescriptor_FacilityBlackoutService_PullFacilityBlackouts,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullFacilityBlackoutsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.FacilityBlackoutServicePromiseClient.prototype.pullFacilityBlackouts =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityBlackoutService/PullFacilityBlackouts",
      request,
      metadata || {},
      methodDescriptor_FacilityBlackoutService_PullFacilityBlackouts
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.CancelFacilityBlackoutRequest,
 *   !proto.stronachgroup.first.racehorse360.FacilityBlackout>}
 */
const methodDescriptor_FacilityBlackoutService_CancelFacilityBlackout =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.FacilityBlackoutService/CancelFacilityBlackout",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.CancelFacilityBlackoutRequest,
    stronachgroup_first_racehorse360_messages_pb.FacilityBlackout,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.CancelFacilityBlackoutRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.FacilityBlackout.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.CancelFacilityBlackoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.FacilityBlackout)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.FacilityBlackout>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.FacilityBlackoutServiceClient.prototype.cancelFacilityBlackout =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityBlackoutService/CancelFacilityBlackout",
      request,
      metadata || {},
      methodDescriptor_FacilityBlackoutService_CancelFacilityBlackout,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.CancelFacilityBlackoutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.FacilityBlackout>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.FacilityBlackoutServicePromiseClient.prototype.cancelFacilityBlackout =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityBlackoutService/CancelFacilityBlackout",
      request,
      metadata || {},
      methodDescriptor_FacilityBlackoutService_CancelFacilityBlackout
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest,
 *   !proto.stronachgroup.first.racehorse360.FacilityBlackout>}
 */
const methodDescriptor_FacilityBlackoutService_ExcludeSingleFacilityBlackoutDate =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.FacilityBlackoutService/ExcludeSingleFacilityBlackoutDate",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ExcludeSingleFacilityBlackoutDateRequest,
    stronachgroup_first_racehorse360_messages_pb.FacilityBlackout,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.FacilityBlackout.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.FacilityBlackout)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.FacilityBlackout>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.FacilityBlackoutServiceClient.prototype.excludeSingleFacilityBlackoutDate =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityBlackoutService/ExcludeSingleFacilityBlackoutDate",
      request,
      metadata || {},
      methodDescriptor_FacilityBlackoutService_ExcludeSingleFacilityBlackoutDate,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.FacilityBlackout>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.FacilityBlackoutServicePromiseClient.prototype.excludeSingleFacilityBlackoutDate =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityBlackoutService/ExcludeSingleFacilityBlackoutDate",
      request,
      metadata || {},
      methodDescriptor_FacilityBlackoutService_ExcludeSingleFacilityBlackoutDate
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest,
 *   !proto.stronachgroup.first.racehorse360.FacilityBlackout>}
 */
const methodDescriptor_FacilityBlackoutService_SetRepeatToForFacilityBlackout =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.FacilityBlackoutService/SetRepeatToForFacilityBlackout",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.SetRepeatToForFacilityBlackoutRequest,
    stronachgroup_first_racehorse360_messages_pb.FacilityBlackout,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.FacilityBlackout.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.FacilityBlackout)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.FacilityBlackout>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.FacilityBlackoutServiceClient.prototype.setRepeatToForFacilityBlackout =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityBlackoutService/SetRepeatToForFacilityBlackout",
      request,
      metadata || {},
      methodDescriptor_FacilityBlackoutService_SetRepeatToForFacilityBlackout,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.FacilityBlackout>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.FacilityBlackoutServicePromiseClient.prototype.setRepeatToForFacilityBlackout =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityBlackoutService/SetRepeatToForFacilityBlackout",
      request,
      metadata || {},
      methodDescriptor_FacilityBlackoutService_SetRepeatToForFacilityBlackout
    );
  };

module.exports = proto.stronachgroup.first.racehorse360;
